import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { memo, useEffect, useMemo } from 'react';
import classNames from 'classnames/bind';
import { getCommonProps, sanitize } from '@beef/utils';
import { Button, Text } from '@beef/ui-kit';
import { handleSendAnalytics, ymPushParams } from "../../utils/ym";
import { getTextFromHtml } from "../../utils/format-string";
import { Card } from "../Card";
import baseStyle from "../../styles/base.module.pcss";
import { getCaptionTextSize, getDescriptionTextSize } from "./utils";
import style from "./styles.module.pcss";
var cn = classNames.bind(_objectSpread(_objectSpread({}, baseStyle), style));
var light = {
  background: style['background-light'],
  button: 'main',
  font: 'grey95'
};
var red = {
  background: style['background-red'],
  button: 'secondary',
  font: 'white'
};
var yellow = {
  background: style['background-yellow'],
  button: 'secondary',
  font: 'grey95'
};
var themeOptions = {
  light: light,
  red: red,
  yellow: yellow
};
export var AdvertisementBanner = /*#__PURE__*/memo(function (_ref) {
  var backgroundImage = _ref.backgroundImage,
    backgroundPosition = _ref.backgroundPosition,
    backgroundSize = _ref.backgroundSize,
    backgroundColor = _ref.backgroundColor,
    index = _ref.index,
    menuTitle = _ref.menuTitle,
    icon = _ref.icon,
    caption = _ref.caption,
    _ref$captionTag = _ref.captionTag,
    captionTag = _ref$captionTag === void 0 ? 'p' : _ref$captionTag,
    description = _ref.description,
    buttonCaption = _ref.buttonCaption,
    label = _ref.label,
    size = _ref.size,
    link = _ref.link,
    _ref$contentPosition = _ref.contentPosition,
    contentPosition = _ref$contentPosition === void 0 ? 'center' : _ref$contentPosition,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'light' : _ref$theme,
    buttonTheme = _ref.buttonTheme,
    withHover = _ref.withHover,
    user = _ref.user;
  var backgroundImageStyle = useMemo(function () {
    var inlineStyle = {};
    if (backgroundImage) {
      inlineStyle.backgroundImage = "url(".concat(backgroundImage, ")");
    }
    if (backgroundPosition) {
      inlineStyle.backgroundPosition = backgroundPosition;
    }
    if (backgroundSize) {
      inlineStyle.backgroundSize = backgroundSize;
    }
    if (backgroundColor) {
      inlineStyle.backgroundColor = backgroundColor;
    }
    return inlineStyle;
  }, [backgroundImage, backgroundPosition, backgroundSize, backgroundColor]);
  var sanitizedCaption = useMemo(function () {
    return caption ? sanitize(caption, ' ') : caption;
  }, [caption]);
  var ymParams = _objectSpread(_objectSpread({}, getCommonProps(user)), {}, {
    item_type: 'banner',
    banner_title: sanitizedCaption,
    banner_description: getTextFromHtml(description),
    banner_url: icon || 'N/A',
    banner_type: 'static',
    banner_position: index,
    object_type: 'catalog',
    catalog_section: _typeof(menuTitle) === 'object' && Object.keys(menuTitle).length === 0 ? 'none' : menuTitle
  });
  useEffect(function () {
    var payload = {
      banners_ev_: _objectSpread({
        action: 'view'
      }, ymParams)
    };
    handleSendAnalytics({
      additionalFields: {
        ecommerce: {
          promoView: {
            promotions: {
              id: "banner_".concat(index),
              creative: icon || 'N/A',
              name: sanitizedCaption,
              position: "menu_".concat(menuTitle, "_static_").concat(index)
            }
          }
        }
      }
    });
    ymPushParams(payload);
  }, []);
  var onClickAnalytics = function onClickAnalytics() {
    var payload = {
      banners_ev_: _objectSpread({
        action: 'click'
      }, ymParams)
    };
    handleSendAnalytics({
      additionalFields: {
        ecommerce: {
          promoClick: {
            promotions: {
              id: "banner_".concat(index),
              creative: icon || 'N/A',
              name: sanitizedCaption,
              position: "menu_".concat(menuTitle, "_static_/").concat(index)
            }
          }
        }
      }
    });
    ymPushParams(payload);
  };
  return /*#__PURE__*/React.createElement(Card, {
    bordered: theme === 'light',
    className: cn('wrapper', size && "wrapper--".concat(size), "".concat(themeOptions[theme].background)),
    withHover: withHover,
    "data-t-id": "components-AdvertisementBanner"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('background-image-wrapper', size && "background-image-wrapper--".concat(size)),
    style: backgroundImageStyle,
    "data-t-id": "components-AdvertisementBanner"
  }, link && link.length > 0 && /*#__PURE__*/React.createElement("a", {
    className: cn('link'),
    href: link,
    onClick: onClickAnalytics
  }, caption && /*#__PURE__*/React.createElement("span", {
    className: cn('sr-only')
  }, sanitizedCaption)), /*#__PURE__*/React.createElement("div", {
    className: cn('content-wrapper')
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('content-container', "content-container--".concat(contentPosition))
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('content', size && "content--".concat(size))
  }, !!icon && /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: icon
  }), !!(caption !== null && caption !== void 0 && caption.length) && /*#__PURE__*/React.createElement("div", {
    className: cn('caption')
  }, /*#__PURE__*/React.createElement(Text, {
    color: themeOptions[theme].font,
    size: getCaptionTextSize(size),
    tagType: captionTag
  }, caption)), !!(description !== null && description !== void 0 && description.length) && /*#__PURE__*/React.createElement("div", {
    className: cn('description')
  }, /*#__PURE__*/React.createElement(Text, {
    color: themeOptions[theme].font,
    size: getDescriptionTextSize(size),
    tagType: "p"
  }, description)))), /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper-button')
  }, !!(label !== null && label !== void 0 && label.length) && /*#__PURE__*/React.createElement("div", {
    className: cn('label', size && "label--".concat(size), "".concat(themeOptions[theme].font))
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size6-m"
  }, label)), !!(buttonCaption !== null && buttonCaption !== void 0 && buttonCaption.length) && /*#__PURE__*/React.createElement("div", {
    className: cn('button-wrap')
  }, /*#__PURE__*/React.createElement(Button, {
    size: "s",
    variant: buttonTheme || themeOptions[theme].button
  }, buttonCaption))))));
});
AdvertisementBanner.displayName = AdvertisementBanner.name;